module.exports = __webpack_public_path__ + "static/media/62.21217548.jpg";